import { IGenericObj } from '../@types/index.shared';

export type IInitSignatureFields = IDCA.IGenericFunc;

interface ISignaturePad {
  clear: () => void;
  fromDataURL: (data: string, options: IGenericObj) => ISignaturePad;
  off: () => void;
  toDataURL: () => string;
}

export function _initSignatureFields(): void {
  const $divs = $('.signature-field');

  $divs.each((_, div) => {
    const $sigdiv = $(div);

    if ($sigdiv.find('canvas').length) {
      return;
    }

    const $canvas: JQuery<HTMLCanvasElement> = $(document.createElement('canvas'));
    const $dataContainer = $sigdiv.closest('.data-container');
    let $formGroup = $sigdiv.closest('.form-group');
    if ($formGroup.length === 0) $formGroup = $dataContainer;
    const $fieldHolder = $formGroup.find('.field-holder');
    const $input = $sigdiv.siblings('input[type="hidden"]');
    const fieldId = $input.attr('id');
    const $button = $sigdiv.siblings('button');
    const readOnly = $sigdiv.data('read-only');

    const deviceRatio: number = 1; // Math.max(window.devicePixelRatio || 1) create bug on mobile refresh page so set to one, maybe to improve for hight DPI screens (https://github.com/szimek/signature_pad#handling-high-dpi-screens)
    const val = $input.val();
    let fieldHolderWidth: number = 0;
    let height: number = 100;
    let width: number = 400;
    let ratio: number = 1;
    let timeout: any;

    function updateSizes() {
      fieldHolderWidth = $fieldHolder.width() || 0;
      height = $sigdiv.data('height');
      width = $sigdiv.data('width');
      ratio = Number((width / height).toFixed(2));

      if (fieldHolderWidth < width) {
        width = fieldHolderWidth;
        height = width / ratio;
      }
    }

    function setCanvas() {
      $canvas.addClass('signature-pad');
      $canvas.prop('id', `${fieldId}_canvas`);
      $canvas.prop('height', `${height}`);
      $canvas.prop('width', `${width}`);
      $canvas.prop('tabindex', '0');

      $canvas.css({
        border: 'none',
        height: `${height}px`,
        margin: '0px',
        padding: '0px',
        width: `${width}px`,
      });
      $sigdiv.append($canvas);
    }

    function resizeCanvas() {
      updateSizes();
      const containerWidth = $fieldHolder.width() || 0;
      const canvasWidth = $canvas.width() || 0;
      const val = $input.val();

      if (
        width < 0 ||
        canvasWidth < 1 ||
        width > containerWidth ||
        (containerWidth > width && canvasWidth < width) ||
        canvasWidth > containerWidth
      ) {
        const newWidth = containerWidth > width ? width : containerWidth;
        const newHeight = newWidth / ratio;

        $canvas
          .attr({
            height: newHeight,
            width: newWidth,
          })
          .css({
            height: `${newHeight}px`,
            width: `${newWidth}px`,
          });

        if (val && val !== '') reloadSignature(val);
      }
    }

    function delayResize() {
      clearTimeout(timeout);
      timeout = setTimeout(resizeCanvas, 250);
    }

    function reloadSignature(val: string | number | string[]) {
      try {
        ($canvas[0].getContext('2d') as any).scale(deviceRatio, deviceRatio);
        signaturePad.clear();
        signaturePad.fromDataURL(`data:${val}`, { height, width });
      } catch (e) {
        ($ as any).log(`Error occured generateStaticSignature: #signature_${fieldId}`);
      }
    }

    function handleOnEnd() {
      const base64 = signaturePad.toDataURL();
      const val = base64.replace('data:', '');

      // Set hidden input value
      if (val && val !== '') {
        $input.val(val).trigger('change');
      } else {
        $input.val('').trigger('change');
      }
    }

    // Set canvas sizes
    updateSizes();

    // Have to set canvas after updateSizes call above to have width and height
    setCanvas();

    const signaturePadOptions = { onEnd: handleOnEnd };

    const signaturePad: ISignaturePad = new (window as any).SignaturePad(
      $canvas[0],
      signaturePadOptions
    );

    if (val && val !== '') reloadSignature(val);

    $button.off('click').on('click', () => {
      signaturePad.clear();
      $input.val('');
    });

    if (readOnly) {
      $button.remove();
      $button.off('click');
      signaturePad.off();
    }

    $formGroup.on('formGroupVisible', resizeCanvas);
    $(window).on('resize', delayResize);
  });
}
